<template>
        <div class="container-fluid" v-if="!loading && this.$route.name.indexOf('print') == -1">
            <div class="navbar-header">
                <!-- <img src="static/images/logo.png" style="width:100px;margin-left:20px" v-if="env=='production'"/> -->
                <a href="javascript:void(0);" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false" v-if="this.$route.meta.requiresAuth"></a>
                <a href="javascript:void(0);" class="bars"></a>
                <a class="navbar-brand" href="#" >PMS</a>
            </div>
            
            <div class="collapse navbar-collapse" id="navbar-collapse" v-if="this.$route.meta.requireAuth">
                <ul class="nav navbar-nav navbar-right">
                  
                    <li class="dropdown">
                                    <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                        <i class="material-icons">more_vert</i>
                                    </a>
                                    <ul class="dropdown-menu pull-right">
                                         <li>
                                            <router-link  to="/user-profile">
                                                <i class="material-icons">person</i>
                                                <span>Profile</span>
                                            </router-link>
                                        </li>
                                         <li>
                                                <router-link id="menu-transaction" to="/logout">
                                                    <i class="material-icons">input</i>
                                                    Log Out
                                                </router-link>
                                        </li>
                                    </ul>
                                </li>
                            
                   
                </ul>
            </div>
            
        </div>
</template>

<script>
export default {
    name: 'TopBar',
    data () {
        return {
            env : '',
            lifetime : 60,
            loading: true
        }
    },
    created() {
        
        this.loading = false
        
    },
    mounted(){
        this.activate();
    },
    methods: {
        activate() {
            var $body = $('body');
            var $overlay = $('.overlay');

            //Open left sidebar panel
            $('.bars').on('click', function () {
                $body.toggleClass('overlay-open');
                if ($body.hasClass('overlay-open')) { $overlay.fadeIn(); } else { $overlay.fadeOut(); }
            });

            //Close collapse bar on click event
            $('.nav [data-close="true"]').on('click', function () {
                var isVisible = $('.navbar-toggle').is(':visible');
                var $navbarCollapse = $('.navbar-collapse');

                if (isVisible) {
                    $navbarCollapse.slideUp(function () {
                        $navbarCollapse.removeClass('in').removeAttr('style');
                    });
                }
            });
        }
    }
}

window.onbeforeunload = function(e) {
    //var unloadTime = new Date();
    //localStorage.unload = unloadTime.getTime()
    //console.log("unload=" + localStorage.unload)
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/TopBar.vue